import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { PageResult } from '@core/model/pagination/page-result';
import { TicketLabor } from '../../models/ticket-labor';
import { FormBuilder, FormGroup } from '@angular/forms';
import { InputMask } from '@core/mask/input-mask';
import { TicketLabourService } from '../../services/ticket-labour.service';
import { ValidationService } from '@shared/services/validation.service';
import { NotifyService } from '@core/services/notify.service';
import { UserService } from '@shared/services/user.service';
import { AuthService } from '@core/services/auth.service';
import { LocationService } from '@shared/services/location.service';
import { PageFilter } from '@core/model/pagination/filter';
import { Salary } from '@core/model/employee/salary';
import { AppUtilService } from '@shared/services/app-util.service';
import { noCommaValue } from '@core/mask/remove-comma';
import { LaborRateType } from '@core/enums/ticket-labor';

@Component({
  selector: 'app-add-hour',
  standalone: false,
  templateUrl: './add-hour.component.html',
  styleUrl: './add-hour.component.css',
  animations: [
    trigger('expandCollapse', [
      state('expanded', style({
        height: '*',
        opacity: 1,
        padding: '*'
      })),
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        padding: '0'
      })),
      transition('expanded <=> collapsed', [
        animate('500ms ease')
      ]),
    ])
  ]
})
export class AddHourComponent implements OnInit {
@Input() ticketId: string;
@Input() primaryAssigneeId: string;
@Input() isCompleted: boolean;
@Output() updateTicket = new EventEmitter<boolean>();
  expandedIndex = -1; // none expanded initially
ticketlaborList: PageResult<TicketLabor> = new PageResult<TicketLabor>();
  ticketlabor: TicketLabor = new TicketLabor();
  form: FormGroup;
  mask = InputMask.getDecimalMask({ includeThousandsSeparator: true });
  workerId:string;
  loading = false;
  pageFilter: PageFilter = {
    pageIndex: 0,
    activeIndex: 0,
    take: 100,
    search: '',
    skip:0,
  };
  laborHourRate: Salary[] = [];

assignees: { id: string | null; fullName: string | null; rHours: string | null; otHours: string | null ;emHours: string | null;pic: string | null}[] =
  [{ id: null, fullName: null ,rHours: null, otHours: null, emHours: null, pic: null}];
currentWorkerId:string;
isManager = true;
 regularHours: string;
  overTimeHours: string;
  estimatedHours: string;
  lastIndex=-1;
  laborRateType = LaborRateType;

  constructor(
    private fb: FormBuilder,
    private service: TicketLabourService,
    public validationService: ValidationService,
    private notifyService: NotifyService,
    public userService: UserService,
  private authService: AuthService,
private location : LocationService,
public appUtilService: AppUtilService,
  )
  {

  }
  toggle(index: number) {
    this.expandedIndex = this.expandedIndex === index ? -1 : index;
    if(this.lastIndex >=0){
      const selectedWorkerId = this.assignees[this.lastIndex].id;
      const getLaborR = this.ticketlaborList?.data.find(x => x.workerId == selectedWorkerId && x.hoursType == this.laborRateType.Regular);
      const getLaborO = this.ticketlaborList?.data.find(x => x.workerId == selectedWorkerId && x.hoursType == this.laborRateType.OverTime);
      this.assignees[this.lastIndex].emHours = getLaborR.estimated.toString();
      this.assignees[this.lastIndex].rHours = getLaborR.hours.toString();
      this.assignees[this.lastIndex].otHours = getLaborO.hours.toString();
      this.lastIndex = -1;
    }
  }

  public async ngOnInit() {

    this.workerId = this.authService.id;

    if (this.ticketId) {
      await this.getData();
    }

  }

  public async getData(){
    this.loading = true;
      const ticketlabor = await this.service.getPaginatedTicketLabors(
        this.pageFilter,
        this.ticketId
      );
      this.laborHourRate = await this.service.getLaborWorkingHourRate(this.ticketId);
      const distinctLabors = ticketlabor.data.reduce((acc, labor) => {
        if (!acc.some((item) => item.workerId === labor.workerId)) {
          acc.push(labor);
        }
        return acc;
      }, []);
if (this.primaryAssigneeId != null) {
    const idx = distinctLabors.findIndex(l => l.workerId === this.primaryAssigneeId);
    if (idx > 0) {                       // >0 so it’s not already first
      const [priorityLabor] = distinctLabors.splice(idx, 1);
      distinctLabors.unshift(priorityLabor);
    }
  }
     // Fill assignees with distinct data
  this.assignees = distinctLabors.map((labor) => ({
    id: labor.workerId,
    fullName: labor.workerName || 'N/A',
    rHours: this.findWorkerHours(ticketlabor.data,labor.workerId,this.laborRateType.Regular),
    otHours: this.findWorkerHours(ticketlabor.data,labor.workerId,this.laborRateType.OverTime),
    emHours: this.findWorkerEstimatedHours(ticketlabor.data,labor.workerId,this.laborRateType.Regular),
    pic: labor.workerPic,
  }));

  // Add an empty entry for new assignments if required

      this.ticketlaborList = {
        ...ticketlabor,
        data: ticketlabor.data.map(item => ({
          ...item,
          total: Number((item.billable * item.rate).toFixed(2)) // Convert the result back to number
        }))
      };
        this.loading = false;
  }

  findWorkerHours(labor: TicketLabor[],workerId:string, hourType: string){
    return labor.find(x => x.workerId == workerId && x.hoursType == hourType).hours.toString();
  }

  findWorkerEstimatedHours(labor: TicketLabor[],workerId:string, hourType: string){
    const foundLabor = labor.find(x => x.workerId === workerId && x.hoursType === hourType);

    if (!foundLabor || isNaN(parseFloat(foundLabor.estimated.toString()))) {
        return "0"; // Return 0 if no valid value is found
    }

    const estimatedValue = parseFloat(foundLabor.estimated.toString());

    return estimatedValue.toString();
  }

  findWorkerHrs(workerId: string, hourType:string){
    const workerHrs = this.ticketlaborList.data.find(x => x.workerId == workerId && x.hoursType == hourType);
    return workerHrs?.hours;
  }

  findWorkerEstimatedHrs(workerId: string, hourType:string){
    const workerHrs = this.ticketlaborList.data.find(x => x.workerId == workerId && x.hoursType == hourType);
    return workerHrs?.estimated;
  }

  findWorkerBillableHrsRegular(workerId: string, hourType:string){
    const workerHrs = this.ticketlaborList.data.find(x => x.workerId == workerId && x.hoursType == hourType);
    return workerHrs?.billable;
  }

  findWorkerHrsRate(workerId: string, hourType:string){
    const workerHrs = this.ticketlaborList.data.find(x => x.workerId == workerId && x.hoursType == hourType);
    return workerHrs?.rate;
  }

  onChangeEstimatedHours(event:Event, index: number, ){
    const inputElement = event.target as HTMLInputElement;
    const value = (inputElement.value);
    this.estimatedHours = value;
      this.assignees[index].emHours = this.estimatedHours.toString();
      this.lastIndex = index;
  }

  onChangeRegularHours(event:Event, index: number, ){
    const inputElement = event.target as HTMLInputElement;
    const value = (inputElement.value);
    this.regularHours = value;
      this.assignees[index].rHours = this.regularHours.toString();
      this.lastIndex = index;
  }

  onChangeOverTimeHours(event:Event, index:number){
    const inputElement = event.target as HTMLInputElement;
    const value  = inputElement.value;
    this.overTimeHours = (value);
    this.assignees[index].otHours = this.overTimeHours.toString();
      this.lastIndex = index;
  }
  safeNumber(value: string, fallback = 0): number {
    const parsed = Number(noCommaValue(value));
    return isNaN(parsed) ? fallback : parsed;
  }
  async onSubmitLaborHours( index:number){
      
    const rHours = this.safeNumber(this.assignees[index].rHours);
    const eHours = this.safeNumber(this.assignees[index].emHours);
    const otHours = this.safeNumber(this.assignees[index].otHours);
    if((eHours === 0 && (this.assignees[index].emHours?.length>0 && this.assignees[index].emHours !== '0')) ||
        (rHours === 0 && (this.assignees[index].rHours?.length>0 && this.assignees[index].rHours !== '0')) ||
        (otHours === 0 && (this.assignees[index].otHours?.length>0 && this.assignees[index].otHours !== '0'))){
       this.notifyService.error({
            message: 'Please enter valid hours.',
      });
      this.assignees[index].emHours = eHours.toString();
      this.assignees[index].rHours = rHours.toString();
      this.assignees[index].otHours = otHours.toString();
      return;
    }
    if(this.assignees[index].emHours.includes('-') || this.assignees[index].rHours.includes('-') || this.assignees[index].otHours.includes('-')){
              this.notifyService.error({
                message: 'Negative values are not allowed.',
              });
              
        return;
      }
    // if(this.assignees[index].emHours.includes('.') || this.assignees[index].rHours.includes('.') || this.assignees[index].otHours.includes('.')){
    //           this.notifyService.error({
    //             message: 'Please enter whole numbers only.',
    //           });
              
    //     return;
    //   }
      this.expandedIndex = -1;
    const labor = new TicketLabor();
    labor.createdOn = new Date();
      labor.createdById = this.workerId;
      labor.updatedOn = new Date();
      labor.updatedById = this.workerId;
      labor.workerId = this.assignees[index].id;
      labor.ticketId = this.ticketId;
      labor.hours=rHours;
      labor.estimated=eHours;
      labor.overtimeHours = otHours;
      labor.rate=0;
      labor.billable = 0;
      labor.hoursType=this.laborRateType.Regular;
    await this.service
        .updateWorkingHours(labor)
        .then(async () => {

          
          this.loading=false;
          this.regularHours ='';
          this.overTimeHours = '';

          this.lastIndex = -1;
          this.updateTicket.emit(true);
          this.getData();
        })
        .catch((error) => {
          this.loading = false;
          error = error.graphQLErrors[0];
          if (error) {
            this.notifyService.error({
              message: error.message,
              type: error.extensions.type,
            });
          } else {
            this.notifyService.error({
              message: 'Failed to add worker hours.',
            });
          }
        });
  }

  formatHeaderValue(value: string): string {
    if (value == null || String(value).trim() === '') {
      return '0';
    }
    const trimmed = String(value).trim();
    const num = Number(noCommaValue(trimmed));
    if (Number.isNaN(num) || num === 0) {
      return '0';
    }
    return trimmed;
  }

  assigned(){
    return this.assignees?.length>0 && this.assignees[0].id? true: false;
  }

  checkUserPermissions(permission: string){
    return this.authService.hasPermission(permission)?? null;
  }
}
